export const formatPhone = (num?: string) => {
    if (!num) {
        return '- не задано -';
    }
    if (!num.startsWith('7')) {
        return num
    }
    return num.replace(/^(\d)(\d{3})(\d{3})(\d{2})(\d{2})$/, '+$1 ($2) $3-$4-$5')
}
